import VinculoList from './list';

export default function VinculoPage() {
  return <VinculoList />;
}
